import * as z from "zod";

import { referrerDetailSchema } from "./shared";

export const getReferrer = {
  name: "getReferrer" as const,
  input: z.object({ referrerId: z.string() }),
  output: z.object({ referrer: referrerDetailSchema }),
};
